import { GroupKeyFilter, useGroupMemberDemoteMutation } from 'shared/graphql';
import { NormalizedGroupMember } from './useGroupMembers';
import { useToast } from 'shared/hooks';
import { recordDebug, recordError } from 'shared/utils/record';

interface UseGroupMemberDemoteOptions {
  group: GroupKeyFilter | undefined | null;
}

export function useGroupMemberDemote(options: UseGroupMemberDemoteOptions) {
  const { showMessage, showSuccess, showError, dismiss } = useToast();

  const [demoteMutation] = useGroupMemberDemoteMutation({
    refetchQueries: ['GroupMembers'],
    awaitRefetchQueries: true,
  });

  const mutate = async (member: NormalizedGroupMember) => {
    if (!options.group) {
      recordDebug(`Group is not defined. Cannot demote member.`);
      return;
    }

    const messageDemotingKey = `DEMOTE_GROUP_MEMBER_REQUEST_${member.id}`;

    try {
      showMessage(`Demoting member from admin of the group.`, { id: messageDemotingKey });

      await demoteMutation({
        variables: {
          user: { id: member.user.id },
          group: { id: options.group.id },
        },
      });

      showSuccess(`Member has been demoted.`);
    } catch (err) {
      recordError(err);

      if (err instanceof Error) {
        showError(err.message);
      }
    }

    dismiss(messageDemotingKey);
  };

  return {
    action: mutate,
  };
}
